import { Reducer } from "redux";

import { HealthPlanMasterResponse } from "../models/Api/User";
import { HealthPlanDispatchTypes } from "../models/DispatchTypes/User";
import { HealthPlanActionDispatchTypes } from "../constants/User";

export const initialState: HealthPlanMasterResponse = {
  loading: false,
  response: [],
};

const HealthPlanReducer: Reducer<
  HealthPlanMasterResponse,
  HealthPlanDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_RESET: {
      return initialState;
    }
    case HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default HealthPlanReducer;
